import { markRaw } from 'vue'
import type { Component } from 'vue'
import ToastComponent from '../../frontend/src/molecules/Toast.vue'
import IconError from '../../frontend/src/icons/IconError.vue'
import { useToast } from 'vue-toastification';

export function useMyToast() {
  const toast = useToast();

  function showToast(
    title: string,
    description: string,
    type: 'success' | 'error' = 'error',
    buttonText = 'Close',
    icon: Component = IconError,
    options: unknown = {}
  ) {
    const safeOptions = options || {}

    const id = toast(
      {
        component: markRaw(ToastComponent),
        props: {
          title,
          description,
          buttonText,
          iconClasses: type === 'error' ? 'text-color-danger' : 'text-color-success',
          icon: markRaw(icon),
          onClose: () => toast.dismiss(id)
        }
      },
      {
        closeOnClick: false,
        hideProgressBar: true,
        icon: false,
        closeButton: false,
        ...safeOptions
      }
    )
    return id
  }

  return { showToast }
}
